import { AuthLayout } from '../../components/layout/AuthLayout'
import { LoginForm } from '../../components/forms/LoginForm'
import { DashboardPreview } from '../../components/layout/DashboardPreview'

export const LoginPage = () => {
  return (
    <AuthLayout preview={<DashboardPreview />}>
      <LoginForm />
    </AuthLayout>
  )
}
